import React from 'react';
import { Badge, Tooltip } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Icon } from '../Icon';
import { Change } from '../../models';
import { updateChange } from '../../redux';

type Props = {
    change: Change;
    /** When true, clicking the badge clears clientReplyPending. */
    dismissable?: boolean;
    /** Called after a dismiss is dispatched (e.g. sync local component state). */
    onDismissed?: () => void;
    className?: string;
};

/**
 * Attention badge for cards with a pending client email reply.
 */
const ClientReplyPendingBadge = ({
    change,
    dismissable = false,
    onDismissed,
    className = '',
}: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    if (!change?.clientReplyPending)
        return null;

    const label = t('changes.badge.client_reply_pending');
    const dismissLabel = t('changes.badge.client_reply_pending_dismiss');

    const onDismiss = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        if (!dismissable)
            return;
        dispatch(updateChange({
            _id: change._id,
            clientReplyPending: false,
        }, true, true) as any);
        onDismissed?.();
    };

    const badge = (
        <Badge
            color="warning"
            className={`w-fit text-xs px-1 ${dismissable ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
            onClick={dismissable ? onDismiss : undefined}
        >
            <Icon type="email" size={3} className="inline" />
            &nbsp;
            {label}
        </Badge>
    );

    return (
        <Tooltip content={dismissable ? dismissLabel : label}>
            <div>{badge}</div>
        </Tooltip>
    );
};

export default ClientReplyPendingBadge;
